import { ProjectType } from '@bulthaup/api/db';
import { Button } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconEdit } from '@tabler/icons-react';

import { RouterOutput, trpc } from '../../../services/trpc';
import { ProjectForm } from './-components/-project-form';

const getInitialValues = (project: RouterOutput['projects']['get']) => {
  return {
    ...project,
    ...project.customer,
    installerId: project.installerId ?? undefined,
    technicianId: project.technicianId ?? undefined,
    homeAddress: project.homeAddress,
    deliveryAddress: project.deliveryAddress,
    installationAddress: project.installationAddress,
    billingAddress: project.billingAddress,
  };
};

export function EditProjectButton({
  project,
}: {
  project: RouterOutput['projects']['get'];
}) {
  const updateProject = trpc.projects.update.useMutation();
  const updateCustomer = trpc.projects.updateCustomer.useMutation();
  const updateAddress = trpc.projects.updateAddress.useMutation();

  return (
    <Button
      leftSection={<IconEdit size={16} />}
      variant="outline"
      onClick={() => {
        modals.open({
          title: 'Modifier les informations du projet',
          size: 'auto',
          children: (
            <ProjectForm
              initialValues={getInitialValues(project)}
              onSubmit={async values => {
                try {
                  await updateProject.mutateAsync({
                    id: project.id,
                    name: values.name,
                    type: values.type as ProjectType,
                    shopId: values.shopId,
                    sellerId: values.sellerId,
                    installerId: values.installerId || null,
                    technicianId: values.technicianId || null,
                    isDeliveryAddressOverride: values.isDeliveryAddressOverride,
                    isInstallationAddressOverride:
                      values.isInstallationAddressOverride,
                    isBillingAddressOverride: values.isBillingAddressOverride,
                  });
                  await updateCustomer.mutateAsync({
                    id: project.customerId,
                    customer1Title: values.customer1Title,
                    customer1FirstName: values.customer1FirstName,
                    customer1LastName: values.customer1LastName,
                    customer1Email: values.customer1Email,
                    customer1Phone: values.customer1Phone,
                    customer2Title: values.customer2Title,
                    customer2FirstName: values.customer2FirstName,
                    customer2LastName: values.customer2LastName,
                    customer2Email: values.customer2Email,
                    customer2Phone: values.customer2Phone,
                    companyName: values.companyName,
                    signer: values.signer,
                    contacts: values.contacts,
                  });

                  await updateAddress.mutateAsync({
                    id: values.homeAddress.id!,
                    ...values.homeAddress,
                  });
                  await updateAddress.mutateAsync({
                    id: values.deliveryAddress.id!,
                    ...values.deliveryAddress,
                  });
                  await updateAddress.mutateAsync({
                    id: values.installationAddress.id!,
                    ...values.installationAddress,
                  });
                  await updateAddress.mutateAsync({
                    id: values.billingAddress.id!,
                    ...values.billingAddress,
                  });

                  modals.closeAll();
                  notifications.show({
                    title: 'Projet modifié avec succès',
                    message: '',
                    color: 'green',
                  });
                } catch {
                  notifications.show({
                    title: 'Erreur',
                    message: 'Une erreur est survenue',
                    color: 'red',
                  });
                }
              }}
            />
          ),
        });
      }}
    >
      Modifier
    </Button>
  );
}
